import React from 'react'

const StatsCard = ({
  title,
  value,
  icon: IconComponent,
  iconColor = 'text-secondary-600',
  iconBgColor = 'bg-orange-50',
  trend,
  trendValue,
  onClick,
}) => {
  const handleClick = () => {
    if (onClick) onClick()
  }

  return (
    <div
      className={`bg-background rounded-xl shadow-sm border border-gray-100 p-4 ${
        onClick ? 'cursor-pointer hover:shadow-md transition-shadow' : ''
      }`}
      onClick={handleClick}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          {IconComponent && (
            <div className={`p-2 rounded-lg ${iconBgColor}`}>
              <IconComponent className={`w-6 h-6 ${iconColor}`} />
            </div>
          )}
          <div>
            <p className="text-sm font-medium text-gray-600">{title}</p>
            <p className="text-2xl font-bold text-gray-900">{value}</p>
          </div>
        </div>

        {trend && trendValue && (
          <div
            className={`flex items-center space-x-1 ${
              trend === 'up'
                ? 'text-success-500'
                : trend === 'down'
                ? 'text-error-900'
                : 'text-gray-500'
            }`}
          >
            <span className="text-sm font-medium">{trendValue}</span>
            {trend === 'up' && (
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M3.293 9.707a1 1 0 010-1.414l6-6a1 1 0 011.414 0l6 6a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L4.707 9.707a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            )}
            {trend === 'down' && (
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M16.707 10.293a1 1 0 010 1.414l-6 6a1 1 0 01-1.414 0l-6-6a1 1 0 111.414-1.414L9 14.586V3a1 1 0 012 0v11.586l4.293-4.293a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default StatsCard
